import { Checkbox } from '@repo/shadcn';
import { FC, useState } from 'react';

interface PermissionProps {
    resourceName: string;
    permissions: {
        create: boolean;
        read: boolean;
        update: boolean;
        delete: boolean;
    };
    onPermissionChange: (
        resourceName: string,
        type: string,
        checked: boolean,
    ) => void;
}

export const Permissions: FC<PermissionProps> = ({
    resourceName,
    permissions,
    onPermissionChange,
}) => {
    const [_setAllChecked] = useState<boolean>(
        permissions.create &&
            permissions.read &&
            permissions.update &&
            permissions.delete,
    );

    const handlePermissionChange = (type: string, checked: boolean) => {
        onPermissionChange(resourceName, type, checked);
    };

    // const handleCheckAll = (checked: boolean) => {
    //   setAllChecked(checked);

    //   handlePermissionChange('create', checked);
    //   handlePermissionChange('read', checked);
    //   handlePermissionChange('update', checked);
    //   handlePermissionChange('delete', checked);
    // };

    return (
        <div className="mr-1 grid grid-cols-5 items-center gap-5 border-b-[1px] py-3">
            <div className="col-span-1 font-semibold capitalize">
                {resourceName}
            </div>
            <div className="col-span-4 flex items-center justify-between gap-8">
                <p>
                    Create:
                    <Checkbox
                        className="ml-1"
                        checked={permissions.create}
                        onCheckedChange={(checked) =>
                            handlePermissionChange('create', checked as boolean)
                        }
                    />
                </p>
                <p>
                    Read:
                    <Checkbox
                        className="ml-1"
                        checked={permissions.read}
                        onCheckedChange={(checked) =>
                            handlePermissionChange('read', checked as boolean)
                        }
                    />
                </p>
                <p>
                    Update:
                    <Checkbox
                        className="ml-1"
                        checked={permissions.update}
                        onCheckedChange={(checked) =>
                            handlePermissionChange('update', checked as boolean)
                        }
                    />
                </p>
                <p>
                    Delete:
                    <Checkbox
                        className="ml-1"
                        checked={permissions.delete}
                        onCheckedChange={(checked) =>
                            handlePermissionChange('delete', checked as boolean)
                        }
                    />
                </p>
                {/* <p>
          <Checkbox
            className="ml-1"
            checked={allChecked}
            onCheckedChange={(checked) => handleCheckAll(checked as boolean)}
          />
          <span className="ml-2">Check All</span>
        </p> */}
            </div>
        </div>
    );
};
